import {LitElement, html, css} from 'lit-element';
import { localizeStringForLanguage } from '../../util/util-lit/util-lit.js';
import { getCropFromArray, preserveLocalURL } from '../../util/util-pcs/util-pcs.js';


class MediaGalleryPromoSwipe extends LitElement {
    static get properties () {
        return {
            assetID: {
                attribute: 'asset-id',
                type: String
            },
            hidden: {
                type: Boolean
            },
            galleryImages: {
                type: Array
            },
            galleryURL: {
                type: String
            },
            title: {
                type: String
            }
        };
    }


    static get styles () {
        return [
            css`
                .carousel-image {
                    display: block;
                    min-height: 150px;
                    width: 100%;
                }

                .carousel-link {
                    display: block;
                    padding-top: 12px;
                    text-decoration: none;
                }

                .title {
                    color: var(--font-color, #222222);
                    font-family: 'Unify Sans', Helvetica, Arial, sans-serif;
                    font-size: calc(16px + (18 - 16) * ((100vw - 320px) / (1200 - 320)));
                    font-weight: 900;
                    font-style: normal;
                    line-height: 1.15;
                    margin: 0;

                }

                .title-block {
                    margin: -15px 0 12px;

                }

                .gallery-description {
                    font-family: 'Unify Sans', Helvetica, Arial, sans-serif;
                    font-size: 12px;
                }
    
                #mediaBadge {
                    display: block;
                    position: relative;
                    margin-right: 8.33333333%;
                    bottom: 30px;
                }
            `
        ];
    }

    constructor () {
        super();

        this.assetID = '';
        this.hidden = false;
        this.galleryImageCount = 0;
        this.galleryImages = [];
        this.promoText = '';
    }

    connectedCallback () {
        super.connectedCallback();

        const MAX_GALLERY_PREV_IMAGES = 5;
        if (this.assetID != '') {
            let url = `${ga_data.site.hosts.gannettCDNAPI}/thorium/gallery/?apiKey=TGgXAxAcR3ktiGl6cRsHSGsLS6ySi6yz&site-code=${window.ga_data.site.uaid}&id=${this.assetID}`;

            fetch(url).then(response => {
                if (response.ok) {
                    response.json().then(res => {
                        let galleryData = res.data;

                        if (galleryData) {
                            let galleryAsset = galleryData.asset;
                            if (galleryAsset) {
                                this.title = galleryAsset.title;
                                if (galleryAsset.pageURL) {
                                    this.galleryURL = preserveLocalURL(galleryAsset.pageURL.long);
                                }
                                if (galleryAsset.links && galleryAsset.links.assets) {
                                    this.galleryImageCount = galleryAsset.links.assets.length;
                                    this.promoText = galleryAsset.promoBrief;
                                    if (galleryAsset.links.assets.length > MAX_GALLERY_PREV_IMAGES) {
                                        this.galleryImages = galleryAsset.links.assets.slice(0, MAX_GALLERY_PREV_IMAGES);
                                    } else {
                                        this.galleryImages = galleryAsset.links.assets;
                                    }
                                }
                            }
                        }
                        
                    });
                }
                this.hidden = !response.ok;
            }, error => {
                // previously newrelic
            });
        }
    }


    render () {
        let languageCfg = {
            'en': {
                'view-all': 'View',
                'photos': 'Photos'
            },
            'es': {
                'view-all': 'Ver',
                'photos': 'Fotos'
            }
        };

        let carouselItems = this.galleryImages;

        if (carouselItems.length > 0) { 
            let targetSrc = getCropFromArray(carouselItems[0].asset.crops, '4_3');
            return html`
            <div class="container carousel" id="galleryWrapper">
                <a class="carousel-link" href=${this.galleryURL}>
                    <div id="carouselWrapper">
                        <img class="carousel-image" src=${targetSrc} />
                    </div>
                    <media-badge id="mediaBadge" mediaType="promo" action=${localizeStringForLanguage(languageCfg, 'view-all')} meta=${this.galleryImageCount + ' ' + localizeStringForLanguage(languageCfg, 'photos')} url=${this.galleryURL}></media-badge>
                    <div class="title-block" on-tap="_fireAnalyticsHeadline">
                        <div class="title">
                            ${this.title}
                        </div>
                    </div>
                </a>
                <div class="gallery-description">
                    ${this.promoText}
                </div>
            </div>
            `;
        }

        return html``;

    }
}

customElements.define('media-gallery-promo', MediaGalleryPromoSwipe);